import type {PressReleasePreview} from '@openapi/press-release';
import type {pressReleaseInformation} from '@press-release-ui/press-release-information';
import type {ComponentPropsWithoutRef} from 'react';

type Return = Pick<
  ComponentPropsWithoutRef<typeof pressReleaseInformation.downloadRow>,
  | 'pressReleaseFile'
  | 'referenceFile'
  | 'mediaUserOnlyPressReleaseFile'
  | 'mediaUserOnlyReferenceFile'
>;

export function fileProps(pressRelease: PressReleasePreview): Return {
  function url(fileName: string) {
    return `/a/?c=${pressRelease.companyId}&r=${pressRelease.releaseId}&f=${fileName}`;
  }

  const isOld = pressRelease.editorVersion === null;

  return {
    pressReleaseFile:
      pressRelease.releaseFileName === ''
        ? null
        : {
            fileName: isOld ? 'プレスリリース' : 'プレスリリース添付資料',
            extension: 'pdf',
            href: url(pressRelease.releaseFileName),
          },
    referenceFile:
      pressRelease.referenceFileName === ''
        ? null
        : {
            fileName: isOld ? '参考資料' : 'プレスリリース添付資料',
            extension: 'pdf',
            href: url(pressRelease.referenceFileName),
          },
    mediaUserOnlyPressReleaseFile:
      pressRelease.mediaReleaseFileName === ''
        ? null
        : {
            fileName: isOld
              ? 'プレスリリース（会員限定）'
              : 'プレスリリース添付資料（会員限定）',
            extension: pressRelease.mediaReleaseFileName.split('.').pop() ?? '',
            href: url(pressRelease.mediaReleaseFileName),
          },
    mediaUserOnlyReferenceFile:
      pressRelease.mediaReferenceFileName === ''
        ? null
        : {
            fileName: isOld
              ? '参考資料（会員限定）'
              : 'プレスリリース添付資料（会員限定）',
            extension:
              pressRelease.mediaReferenceFileName.split('.').pop() ?? '',
            href: url(pressRelease.mediaReferenceFileName),
          },
  };
}

export const isAllFileNull = (files: Return): boolean => {
  return Object.values(files).every((file) => file === null);
};
